import React, { Component } from 'react';
import { Link } from 'gatsby';
import Tags from './tag';

const formatDate = raw => {
  if (!raw) return '';
  const d = new Date(raw);
  if (isNaN(d.getTime())) return raw.split('T')[0];
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
};

export default props => {
  const hasImage = Boolean(props.node.frontmatter.thumbnail);
  return (
    <article
      className={`post-card ${props.postClass} ${
        hasImage ? `with-image` : `no-image`
      }`}
    >
      {hasImage ? (
        <ContentWithImage props={props} />
      ) : (
        <ContentNoImage props={props} />
      )}
    </article>
  );
};

class ContentNoImage extends Component {
  render() {
    const { props } = this.props;
    return (
      <Link
        to={'/' + props.sourceInstanceName + props.node.fields.slug}
        className="post-card-link"
      >
        <div className="post-card-content">
          <div className="post-card-body-group">
            <div className="post-card-meta">
              <span className="post-card-date">
                {formatDate(props.node.frontmatter.date)}
              </span>
              <Tags tags={props.node.frontmatter.tags} />
            </div>
            <h2 className="post-card-title">
              {props.node.frontmatter.title || props.node.fields.slug}
            </h2>
            <p className="post-card-body">
              {props.node.frontmatter.description || props.node.excerpt}
            </p>
          </div>
          <span className="post-card-readmore">Read more →</span>
        </div>
      </Link>
    );
  }
}

class ContentWithImage extends Component {
  render() {
    const { props } = this.props;
    const description = props.node.frontmatter.description || props.node.excerpt;
    const thumb = props.node.frontmatter.thumbnail.childImageSharp.fluid.src;
    return (
      <Link
        to={'/' + props.sourceInstanceName + props.node.fields.slug}
        className="post-card-link"
      >
        <div
          className="post-card-image"
          style={{ backgroundImage: `url(${thumb})` }}
          role="img"
          aria-label={props.node.frontmatter.title}
        />
        <div className="post-card-content">
          <div className="post-card-body-group">
            <div className="post-card-meta">
              <span className="post-card-date">
                {formatDate(props.node.frontmatter.date)}
              </span>
              <Tags tags={props.node.frontmatter.tags} />
            </div>
            <h2 className="post-card-title">
              {props.node.frontmatter.title || props.node.fields.slug}
            </h2>
            {description && <p className="post-card-body">{description}</p>}
          </div>
          <span className="post-card-readmore">Read more →</span>
        </div>
      </Link>
    );
  }
}
